import Vue from 'vue'
import 'babel-polyfill'
import util from './util';
import validate from './validate';
import layer from 'vue-layer';
import VueLazyload from 'vue-lazyload';
import 'js/filter';
import $ from 'js/lib/jquery-1.12.0.min.js';
import '@/iconfont/iconfont.css';
import 'scss/common.scss';
Vue.use(util);
Vue.use(validate);
Vue.prototype.$layer = layer(Vue);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/static/placeholder.jpg',
  loading: '/static/placeholder.jpg',
  attempt: 1
});
/* element-ui */
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

var config = require('../../config');

if (process.env.NODE_ENV === 'development') {
    // 编译环境
    window.ajaxUrl = config.dev.ajaxUrl;
    window.ajaxUrl1 = config.dev.ajaxUrl1;
    window.ajaxUrl2 = config.dev.ajaxUrl2;
    window.ajaxUrl3 = config.dev.ajaxUrl3;
    // window.ajaxUrl5 = config.dev.ajaxUrl5;
    window.accountBaseUrl = config.dev.accountBaseUrl;
    window.orderUrl = config.dev.orderUrl;
    window.jumpDeal = config.dev.jumpDeal;
    window.landUrl = config.dev.landUrl;
    window.getDealList = config.dev.getDealList;
    window.stockUrl = config.dev.stockUrl;
    window.currentUrl = config.dev.currentUrl;
    window.checkDownload=config.dev.checkDownload;
    window.bindTelUrl=config.dev.bindTelUrl;
    window.domainUrl=config.dev.domainUrl;
} else {
    // PDT环境
    if (process.env.type === 'pdt') {
        window.ajaxUrl = config.pdt.ajaxUrl;
        window.ajaxUrl1 = config.pdt.ajaxUrl1;
        window.ajaxUrl2 = config.pdt.ajaxUrl2;
        window.ajaxUrl3 = config.pdt.ajaxUrl3;
        // window.ajaxUrl5 = config.pdt.ajaxUrl5;
        window.accountBaseUrl = config.pdt.accountBaseUrl;
        window.orderUrl = config.pdt.orderUrl;
        window.jumpDeal = config.pdt.jumpDeal;
        window.landUrl = config.pdt.landUrl;
        window.getDealList = config.pdt.getDealList;
        window.stockUrl = config.pdt.stockUrl;
        window.currentUrl = config.pdt.currentUrl;
        window.checkDownload=config.pdt.checkDownload;
        window.bindTelUrl=config.pdt.bindTelUrl;
        window.domainUrl=config.pdt.domainUrl;
    // UAT环境
    } else {
        window.ajaxUrl = config.build.ajaxUrl;
        window.ajaxUrl1 = config.build.ajaxUrl1;
        window.ajaxUrl2 = config.build.ajaxUrl2;
        window.ajaxUrl3 = config.build.ajaxUrl3;
        // window.ajaxUrl5 = config.build.ajaxUrl5;
        window.accountBaseUrl = config.build.accountBaseUrl;
        window.orderUrl = config.build.orderUrl;
        window.jumpDeal = config.build.jumpDeal;
        window.landUrl = config.build.landUrl;
        window.getDealList = config.build.getDealList;
        window.stockUrl = config.build.stockUrl;
        window.currentUrl = config.build.currentUrl;
        window.checkDownload=config.build.checkDownload;
        window.bindTelUrl=config.build.bindTelUrl;
        window.domainUrl=config.build.domainUrl;
    }
}

Vue.config.productionTip = false;

import top from 'common/top';
import bottom from 'common/bottom';
import sidebar from 'common/sidebar';
import leftnav from 'common/leftnav';
Vue.component('Top', top);
Vue.component('Bottom', bottom);
Vue.component('Sidebar', sidebar);
Vue.component('leftnav', leftnav);

export default {
  methods:{
  	hideList: function(event) {
  		var _this=this;
  			  if(event && (event.target.id != 'btn') && event.target.className!='el-input__inner') {
						 document.getElementsByClassName('stock-list')[0].style.display='none';
					}else if(event && (event.target.id == 'btn') && event.target.className!='el-input__inner' && (document.getElementsByClassName('el-input__inner')[0].value=='产品')){
						 document.getElementsByClassName('stock-list')[0].style.display='block';
					}else if(event && (event.target.id == 'btn') && event.target.className!='el-input__inner' && (document.getElementsByClassName('el-input__inner')[0].value!='产品')){
						 document.getElementsByClassName('stock-list')[0].style.display='none';
					}
			  if (event && (event.target.className!='soft-nav isFixed')&&(event.target.className!= 'toggle-btn')) {
			  	    app.__vue__._data.isShow=false;
			  }else if(event && (event.target.className== 'toggle-btn')){
			  	    app.__vue__._data.isShow=true;
			  }
		}
  }
}

var noScroll, scroll, oDiv = document.createElement("DIV");
oDiv.style.cssText = "position:absolute; top:-1000px; width:100px; height:100px; overflow:hidden;";
noScroll = document.body.appendChild(oDiv).clientWidth;
oDiv.style.overflowY = "scroll";
scroll = oDiv.clientWidth;
document.body.removeChild(oDiv);

window.scrollBar = noScroll - scroll;

//baidu static
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?d5fe6f5aab8b307a77ef65b148c1c22a";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();



// WEBPACK FOOTER //
// ./src/js/common.js